// extracted by mini-css-extract-plugin
export default {"page-container":"profile-app_page-container__9g97h","context":"profile-app_context__jfUDY"};